<template>
  <div class="roleTree">
    <div class="roleTree__header">
      <el-input v-model="searchFactor" placeholder="请输入角色" size="small">
        <template #prefix><i class="el-icon-search el-input__icon" /></template>
      </el-input>
      <slot></slot>
    </div>
    <div class="roleTree__body" v-loading="treeLoading">
      <el-tree ref="roletree" :data="dataList" v-if="Array.isArray(dataList) && dataList.length > 0" default-expand-all
        highlight-current node-key="roleID" @node-click="selectNode" :render-content="renderContent"
        :props="treeDefaultProps">
      </el-tree>
      <slot v-else :data="{dataList, treeLoading}">
        <div class="empty">
          <img :src="require('@/CommonDP/assets/暂无数据.png')" alt="暂无数据">
          <span>{{treeLoading ? '加载中...' : '无数据'}}</span>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  data: () => {
    const staticProps = {
      $topLevel: "$topLevel",
      $id: "roleID",
      children: "children",
      label: "label"
    };
    return {
      searchFactor: "",
      dataList: [],
      staticProps,
      treeLoading: false,
      currentSelectedID: ""
    };
  },
  props: {
    enableModifiy: {
      default: () => false,
      type: Boolean
    },
    defaultProps: {
      type: Object
    },
    data: {
      type: Array,
      default: () => []
    },
    lazy: {
      default: false
    },
    // 返回值为Promise的function
    load: {
      type: Function
    }
  },
  computed: {
    $topLevel() {
      return this.getProps("$topLevel");
    },
    $id() {
      return this.getProps("$id");
    },
    treeDefaultProps() {
      return {
        children: this.getProps("children"),
        label: this.getProps("label")
      };
    }
  },
  methods: {
    getProps(tag) {
      if (tag in this.defaultProps) return this.defaultProps[tag];
      return this.staticProps[tag];
    },
    async getTreeInfo() {
      this.treeLoading = true;
      if (this.lazy && typeof this.load === "function") {
        const data = await this.load();
        this.treeDataProcessor(data);
      } else {
        this.treeDataProcessor(this.data);
      }
      this.treeLoading = false;
    },

    treeDataProcessor(data) {
      let fakeData = Array.isArray(data) ? data : [];
      fakeData.forEach(item => {
        item[this.$topLevel] = true; // 标记一级节点
      });
      this.dataList = fakeData;
    },

    selectNode(node) {
      if (node[this.$topLevel]) this.currentSelectedID = "";
      else {
        this.currentSelectedID = node[this.$id];
      }
      // emit it
      if ("node-click" in this.$listeners) {
        this.$emit("node-click", node);
      }
    },
    renderContent(h, { node }) {
      const selected = this.currentSelectedID;
      const _this = this;
      let inject =
        selected === node.data[this.$id] && this.enableModifiy
          ? [
              h(
                "div",
                {
                  attrs: {
                    class: "roleMaintain"
                  }
                },
                [
                  h("img", {
                    attrs: {
                      src: require("@/xgzdAssets/permission/edit.svg")
                    },
                    on: {
                      click: function() {
                        return _this.editNode(node.data);
                      }
                    }
                  }),
                  h("img", {
                    attrs: {
                      src: require("@/xgzdAssets/permission/delete.svg")
                    },
                    on: {
                      click: function() {
                        return _this.delNode(node.data);
                      }
                    }
                  })
                ]
              )
            ]
          : [];

      return h(
        "div",
        {
          attrs: {
            class: "treenodeManual"
          }
        },
        [
          h("img", {
            attrs: {
              src: node.data[this.$topLevel]
                ? require("@/xgzdAssets/permission/class.svg")
                : require("@/xgzdAssets/permission/role.svg")
            }
          }),
          h("div", {
            domProps: {
              innerHTML: node.data[this.$topLevel]
                ? node.label
                : this.highLightSearchedText(node.label)
            },
            attrs: {
              class: "ellipsis infoText",
              title: node.label
            }
          }),
          ...inject
        ]
      );
    },

    highLightSearchedText(text) {
      text = text || "";
      text = text.replaceAll(
        this.searchFactor,
        `<span style="color:#3873fe;">${this.searchFactor}</span>`
      );
      return text;
    },
    async editNode(data) {
      if (this.$listeners["edit-node"]) {
        this.$emit("edit-node", { data, ref: this });
      } else {
        console.warn(
          '[role-tree] you need inject @edit-node="methodName" in <role-tree /> tag '
        );
      }
    },
    async delNode(data) {
      if (this.$listeners["edit-node"]) {
        this.$emit("del-node", { data, ref: this });
      } else {
        console.warn(
          '[role-tree] you need inject @del-node="methodName" in <role-tree /> tag '
        );
      }
    }
  },
  created() {
    this.getTreeInfo();
  }
};
</script>

<style lang="scss" scoped>
.submitForm {
  min-height: 100px;
  padding: 2px 10px 0px 10px;
  box-sizing: border-box;
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  > span.label {
    margin: 20px 0px 5px 0px;
  }
  * {
    font-weight: 300 !important;
  }
}
.roleTree {
  user-select: none;
  $rt_height: 40px;
  height: 100%;
  width: 100%;
  > * {
    width: 100%;
  }
  &__header {
    height: $rt_height;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    border-bottom: 1px solid #f4f5fa;
    /deep/ .el-input {
      margin: 0px 5px;
    }
  }
  &__body {
    $scale_size: 14px;
    padding-top: 5px;
    height: calc(100% - #{$rt_height});
    overflow: hidden auto;
    .empty {
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      justify-content: center;
      align-items: center;
      height: 50%;
      overflow: hidden;
      > span {
        margin-top: 20px;
        color: gray;
        font-size: 14px;
        font-weight: 300;
      }
      > img {
        height: 150px;
        width: 150px;
      }
    }
    /deep/ .el-tree {
      .treenodeManual {
        display: grid;
        grid-template-columns: 20px 1fr 40px;
        width: 100%;
        overflow: hidden;
        align-items: center;
        justify-content: center;
        > img {
          margin-right: 4px;
          height: $scale_size;
          width: $scale_size;
        }
        .infoText {
          font-family: "PingFang SC";
          font-style: normal;
          color: #303133;
          line-height: 20px;
          font-size: $scale_size !important;
        }
      }
      .roleMaintain {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
        justify-content: flex-start;
        img {
          margin: 0 3px;
          height: $scale_size;
          width: $scale_size;
        }
      }
    }
  }
}
</style>